import { NamedEntityPropertyType } from '../../../../common-modules/interfaces/NamedEntityPropertyType';

export enum CompanyStatus {
    Enabled = 1,
    Disabled = 2,
    Pending = 3,
}

export const CompanyStatusMapping: { [type in CompanyStatus]: { name: string } } = {
    [CompanyStatus.Enabled]: {
        name: $localize`Enabled`,
    },
    [CompanyStatus.Disabled]: {
        name: $localize`Disabled`,
    },
    [CompanyStatus.Pending]: {
        name: $localize`Pending`,
    },
};

export class CompanyStatusLabels implements NamedEntityPropertyType {
    public getName(type: string | CompanyStatus): string {
        return CompanyStatusMapping[type as unknown as CompanyStatus].name;
    }

    public getAllTypes(permissions?: string[]): CompanyStatus[] {
        if (permissions) {
            return Object.keys(CompanyStatusMapping).filter((key) => permissions?.includes(key)) as any as CompanyStatus[];
        } else {
            return Object.keys(CompanyStatusMapping) as any as CompanyStatus[];
        }
    }
}

export enum BreachWarningStatus {
    None = 'none',
    Standard = 'standard',
    Plus = 'plus',
}
